export default {
    feedAttachment(state) {
        return state.feedAttachment;
    }
}